import React, { useState, useEffect } from 'react'
import { Outlet, NavLink, useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

const baseNavItems = [
  { path: '/', label: 'Dashboard' },
  { path: '/season', label: 'Season' },
  { path: '/career', label: 'Career' },
  { path: '/goals', label: 'Goals' },
  { path: '/networking', label: 'Networking' },
  { path: '/profile', label: 'Profile' },
]

export default function Layout({ session }) {
  const navigate = useNavigate()
  const [profile, setProfile] = useState(null)
  const [menuOpen, setMenuOpen] = useState(false)

  const navItems = profile?.is_admin
    ? [{ path: '/admin', label: 'Admin' }]
    : baseNavItems

  useEffect(() => {
    if (session?.user?.id) {
      supabase.from('profiles').select('*').eq('id', session.user.id).single()
        .then(({ data }) => { if (data) setProfile(data) })
    }
  }, [session])

  const handleSignOut = async () => {
    await supabase.auth.signOut()
    navigate('/auth')
  }

  return (
    <div style={{ minHeight: '100vh', background: '#080806', color: '#F5F3ED', fontFamily: "'DM Sans', sans-serif" }}>

      {/* Nav */}
      <nav style={{ position: 'sticky', top: 0, zIndex: 100, background: '#111109', borderBottom: '1px solid rgba(255,255,255,0.07)', padding: '0 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 56 }}>
        
        {/* Logo */}
        <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: 20, letterSpacing: 4, color: '#FDD700', flexShrink: 0 }}>
          JNM <span style={{ fontSize: 11, color: '#7A7860', letterSpacing: 2 }}>Career Hub</span>
        </div>

        {/* Desktop nav links */}
        <div className="desktop-nav" style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {navItems.map(item => (
            <NavLink key={item.path} to={item.path} end={item.path === '/'}
              style={({ isActive }) => ({
                padding: '6px 12px', textDecoration: 'none', fontSize: 13,
                fontWeight: isActive ? 600 : 400,
                color: isActive ? '#FDD700' : '#7A7860',
                background: isActive ? 'rgba(253,215,0,0.1)' : 'transparent',
                borderRadius: 4, whiteSpace: 'nowrap',
              })}>
              {item.label}
            </NavLink>
          ))}
        </div>

        {/* Desktop right */}
        <div className="desktop-nav" style={{ display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
          <span style={{ fontSize: 13, color: '#7A7860' }}>{profile?.full_name || ''}</span>
          <button onClick={handleSignOut} style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.07)', color: '#7A7860', fontSize: 12, fontFamily: "'DM Sans', sans-serif", fontWeight: 600, padding: '6px 12px', borderRadius: 4, cursor: 'pointer' }}>
            Sign Out
          </button>
        </div>

        {/* Mobile hamburger */}
        <button
          className="mobile-menu-btn"
          onClick={() => setMenuOpen(!menuOpen)}
          style={{ background: 'none', border: 'none', color: '#F5F3ED', fontSize: 24, cursor: 'pointer', padding: '4px 8px', lineHeight: 1 }}>
          {menuOpen ? '✕' : '☰'}
        </button>
      </nav>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div style={{ position: 'fixed', top: 56, left: 0, right: 0, background: '#111109', borderBottom: '1px solid rgba(255,255,255,0.07)', zIndex: 99 }}>
          {navItems.map(item => (
            <NavLink key={item.path} to={item.path} end={item.path === '/'}
              onClick={() => setMenuOpen(false)}
              style={({ isActive }) => ({
                display: 'block', padding: '14px 20px', textDecoration: 'none',
                fontSize: 15, fontWeight: isActive ? 600 : 400,
                color: isActive ? '#FDD700' : '#F5F3ED',
                background: isActive ? 'rgba(253,215,0,0.08)' : 'transparent',
                borderBottom: '1px solid rgba(255,255,255,0.04)',
              })}>
              {item.label}
            </NavLink>
          ))}
          <div style={{ padding: '14px 20px' }}>
            <button onClick={handleSignOut} style={{ background: 'none', border: 'none', color: '#7A7860', fontSize: 14, cursor: 'pointer', fontFamily: "'DM Sans', sans-serif" }}>
              Sign Out
            </button>
          </div>
        </div>
      )}

      {/* Content */}
      <main style={{ maxWidth: 1100, margin: '0 auto', padding: '32px 20px' }}>
        <Outlet />
      </main>

      <style>{`
        .desktop-nav { display: flex !important; }
        .mobile-menu-btn { display: none !important; }
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .mobile-menu-btn { display: block !important; }
        }
      `}</style>
    </div>
  )
}
